import { createContext, SyntheticEvent, useContext } from 'react';

export type PortalAuthMode = 'auth0' | 'cookie';

export interface PortalAuthContextValue {
  mode: PortalAuthMode;
  // Every logout control sits on a link, so logout suppresses that link's own navigation before
  // it starts. Without that, the browser unloads the page and aborts the in-flight sign-out,
  // leaving the session cookie valid.
  logout: (event?: SyntheticEvent) => Promise<void>;
}

export const PortalAuthContext = createContext<PortalAuthContextValue | undefined>(undefined);

export const usePortalAuth = (): PortalAuthContextValue => {
  const value = useContext(PortalAuthContext);
  if (!value) {
    throw new Error('usePortalAuth must be used inside a PortalAuthProvider');
  }
  return value;
};
